// extracted by mini-css-extract-plugin
export default {"inputRow":"style_inputRow__itr5F","label":"style_label__Nho93","select":"style_select__0w7lv"};